<template>
	<div id="privacy" class="policy-document">
		<h2>小全智行隐私政策</h2>

		<div class="policy-content">
			<div class="info-box">
				<div class="info-item">
					<text class="info-label">应用运营方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">应用研发方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">注册地址:</text>
					<text class="info-value">深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="info-item">
					<text class="info-label">联系方式:</text>
					<text class="info-value">dev@ledrift.net</text>
				</div>
			</div>
			<h3>引言</h3>
			<p>深圳乐漂科技有限公司深知个人信息对您的重要性，并承诺保护您的隐私安全。本《隐私政策》旨在向您说明，在您使用"小全智行"App时，我们如何收集、使用、存储、共享和保护您的个人信息。</p>

			<h3>一、我们如何收集和使用您的个人信息</h3>
			<p>我们仅会出于以下目的和功能，收集和使用您的个人信息：</p>
			<p>1. 账号注册与登录：使用手机号码创建账号，用于验证身份、登录和接收重要通知。</p>
			<p>2. 核心物联网功能：位置信息用于定位车辆、导航寻车；蓝牙权限用于连接并控制车辆。</p>
			<p>3. 设备信息：用于保障账号安全、识别App崩溃问题及进行数据统计分析。</p>
			<p>4. 支付功能：订单支付信息由合作的第三方支付机构处理。</p>

			<div>
				<p>我们需要说明权限如下:</p>
				<p>1、我们需要访问摄像头进行拍照（或本地图册），以拍照（或本地图片）作为用户头像设置，用于支持用户通过拍摄照片的方式，直接获取图像并设置为个人账号头像，提升账号个性化设置的便捷性。</p>
				<p>2、我们需要访问联系人通讯录信息、本机电话号码，分享车辆设备给家人或朋友使用，调用通讯录联系人。该权限用于帮助用户快速从手机通讯录中选取共享对象，无需手动输入对方手机号码，大幅提升车辆设备共享操作的便捷性与准确性，优化多人协同使用车辆设备的体验。
				</p>
				<p>3、我们需要获取设备信息、设备SIM卡信息（ICCID）、位置的权限，以便生成与车辆操作的操作日志，实现操作可追溯，方便用户核查历史记录、技术团队排查异常问题，保障车辆使用安全。</p>
				<p>4、我们需要获取设备写入、位置权限，用于实现硬件设备功能更新，通过该权限，应用可安全获取车辆设备的更新推送、校验更新包完整性，并向设备传输合规更新文件，确保车辆控制系统(如远呈控制模块、安全监测功能)始终运行在最新、最稳定的版本，修复潜在漏洞、优化功能体验，保障车辆使用的安全性与功能性。
				</p>
				<p>5、我们需要在你分享或接被分享的信息时，需要在本地访问你的剪切板，读取其中包含的口令，分享码，链接，以实现跳转，分享等功能或服务。</p>
				<p>6、微信登录与苹果登录
					使用目的:帮助用户使用微信或者苹果账号进行登录使用场景:用户进行登录时可以选择微信或者苹果登录</p>
				<p>7、收集/共享信息:网络访问，获取Wi-Fi状态，读取电话状态，使用存储权限，设备标识信息(包括IMEI、IMSI、SUPI、SUCI、设备序列号、OAID、MEID、MAC地址、ICCID)，剪切板，位置，联系人，本机电话号码，图片，音视频等个人信息
				</p>
			</div>



			<h3>二、我们如何使用Cookie和同类技术</h3>
			<p>我们可能使用Cookie来记录您的登录状态、偏好设置，以提升服务体验。</p>

			<h3>三、我们如何共享、转让、公开披露您的个人信息</h3>
			<p>1. 共享：我们不会出售您的个人信息。我们可能会与地图服务提供商、推送服务提供商等第三方共享必要的个人信息。</p>
			<p>2. 转让与公开披露：我们不会将您的个人信息转让给任何公司、组织和个人，也不会公开披露，除非事先获得您的明确同意或法律法规强制要求。</p>

			<h3>四、我们如何存储和保护您的个人信息</h3>
			<p>1. 存储地点：我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。</p>
			<p>2. 存储期限：我们仅在为实现本政策所述目的所必需的期限内保留您的信息。</p>
			<p>3. 安全措施：我们采用多种安全技术和管理措施来保护您的信息不被未授权访问、泄露、篡改或毁坏。</p>

			<h3>五、您的权利</h3>
			<p>您有权访问、更正、删除您的个人信息；改变您授权同意的范围；注销您的账户；获取个人信息副本。</p>

			<h3>六、本政策如何更新</h3>
			<p>我们可能会适时更新本政策。更新后，我们会通过App推送通知、网站公告等显著方式提醒您。</p>

			<h3>七、如何联系我们</h3>
			<p>如果您对本政策有任何疑问、意见或建议，请通过以下方式联系我们：</p>
			<p>公司名称：深圳乐漂科技有限公司</p>
			<p>数据保护负责人邮箱：dev@ledrift.net</p>
			<p>地址：深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</p>

			<p class="highlight-text">生效日期：2025年05月01日</p>
		</div>
	</div>

</template>



<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}

	body {
		background-color: #f5f7fa;
		color: #333;
		line-height: 1.6;
		padding: 20px;
	}

	.policy-document {
		border-radius: 12px;
		padding: 40px;
		margin-bottom: 40px;
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
		background-color: #ffffff;
	}

	.policy-document h2 {
		color: #2c3e50;
		margin-bottom: 20px;
		text-align: center;
		font-size: 1.8rem;
	}

	.policy-content {
		padding: 20px;
		background: #f9f9f9;
		border-radius: 8px;
	}

	.info-box {
		width: 100%;
		padding: 20px;
		background: #e7f4fc;
		border-radius: 8px;
		margin-bottom: 25px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.info-item {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		line-height: 1.8;
	}

	.info-item:last-child {
		margin-bottom: 0;
	}

	.info-label {
		font-weight: 600;
		min-width: 100px;
		flex-shrink: 0;
		color: #333;
	}

	.info-value {
		flex-grow: 1;
		word-break: break-word;
		color: #666;
	}

	.policy-content h3 {
		color: #3498db;
		margin: 20px 0 10px;
	}

	.policy-content p {
		margin-bottom: 15px;
	}

	.back-button {
		display: inline-block;
		margin-top: 20px;
		background: #7f8c8d;
		color: white;
		padding: 10px 18px;
		border-radius: 6px;
		text-decoration: none;
		transition: background 0.3s ease;
	}

	.back-button:hover {
		background: #636e72;
	}

	.page-footer {
		text-align: center;
		padding: 20px;
		color: #7f8c8d;
		font-size: 0.9rem;
		border-top: 1px solid #ddd;
		margin-top: 20px;
	}

	.company-details {
		margin-top: 30px;
		padding: 20px;
		background: white;
		border-radius: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	.company-details h3 {
		color: #2c3e50;
		margin-bottom: 15px;
		text-align: center;
	}

	.company-details p {
		margin: 10px;
	}

	.highlight-text {
		color: #e74c3c;
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.container {
			grid-template-columns: 1fr;
		}

		h1 {
			font-size: 2rem;
		}

		.policy-document {
			padding: 20px;
		}

		.info-box {
			padding: 15px;
		}

		.info-label {
			min-width: 90px;
			margin-bottom: 5px;
		}

		.info-item {
			flex-direction: column;
			margin-bottom: 15px;
		}
	}
</style>